import { Component, OnInit, ViewEncapsulation } from '@angular/core' 
import { Constants } from 'app/shared/constant/constants';
import { PurposeList } from 'app/shared/constant/purpose-list';
import { ReqGetCurrencyMaster } from 'app/shared/models/shared-models';
import { MasterDataService } from 'app/shared/services/master-data.service';
import { CurrencyConverterService } from '../services/currency-converter.service';
import { ToastrService } from 'ngx-toastr';
import { GTMDataLayerService } from 'app/shared/services/gtmDataLayer.service';
import { ConstantsKey } from 'app/shared/constant/constants-keys';

@Component({
  selector: 'currency-converter',
  templateUrl: './currency-converter.component.html',
  styleUrls: ['../../../../@core/scss/angular/libs/select.component.scss',
              './currency-converter.component.scss'],
  providers:[CurrencyConverterService],
  encapsulation: ViewEncapsulation.None
})
export class CurrencyConverterComponent implements OnInit {
  public showLoader: boolean = false;
  public reqGetCurrencyMaster: ReqGetCurrencyMaster = new ReqGetCurrencyMaster();
  public currencyItems : any=[];
  public surrenderingCurrencyCode : any;
  public requiredCurrencyCode : any;
  public amount : any;
  public currencyConverterResponse : any;
  public convertedValue : any;
  public custMobile = "";

  constructor(
     public masterDataService : MasterDataService,
     public currencyConverterService : CurrencyConverterService,
     public toast : ToastrService,
     public gtmPushService: GTMDataLayerService
  ) { 
    this.requiredCurrencyCode = 'EUR';
    this.surrenderingCurrencyCode = 'USD';
  }

  ngOnInit() { 

    let consumerData = localStorage.getItem(ConstantsKey.CONSUMER_DATA);
    if(consumerData) {
      consumerData = JSON.parse(consumerData);
      this.custMobile = consumerData["mobile"];
    }

    this.getCurrencies();
  }

  getCurrencies() {
    this.showLoader = true;
    this.reqGetCurrencyMaster.cartType = ""
    this.reqGetCurrencyMaster.cartType = PurposeList.purpose[0].remittanceType;
    this.reqGetCurrencyMaster.countryCode = "US";
    this.reqGetCurrencyMaster.issuer = "";
    this.reqGetCurrencyMaster.partnerId = Constants.partnerId;
    this.reqGetCurrencyMaster.product = Constants.productsEnum[2];

    this.masterDataService.getCurrenciesList(this.reqGetCurrencyMaster).subscribe(result => {
      this.currencyItems = result.body;
      this.currencyItems.push({ currencyCode: "INR" });

      console.log("currencyItems>>>",this.currencyItems);

    });
  }


  convertCurrency(){
    this.showLoader = true;
    if(this.amount){


    let evtObj = {
      "event": "currency-converter",
      "from_currency": this.surrenderingCurrencyCode,
      "to_currency": this.requiredCurrencyCode,
      "converted_amount": this.amount,
      "mobile": this.custMobile != "" ? "91"+this.custMobile : ""
    };
    this.gtmPushService.dataLayerPushData(evtObj);

      this.currencyConverterService.getCurrencyConverterValues(this.surrenderingCurrencyCode,this.requiredCurrencyCode,this.amount, "WALLET").subscribe(result => {
        this.currencyConverterResponse = result.body;
        this.convertedValue = this.currencyConverterResponse.formattedCurrencyAmountWithTaxes;
      }, error => {
        this.toast.error(error.error.message);
      });
    }else{
      this.toast.error('Please enter amount!');
    }
  }
  keyPressNumbers(event) {
    var charCode = (event.which) ? event.which : event.keyCode;
    // Only Numbers 0-9
    if ((charCode < 48 || charCode > 57)) {
      event.preventDefault();
      return false;
    } else {
      return true;
    }
  }
}
